import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { ADMIN_ERROR_404_PATH, hasAdminPermission } from './admin-permission.utils';

export const AdminPermissionGuard: CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const navigationService = inject(NavigationService);

  return navigationService.get().pipe(
    map((navigation) => {
      if (hasAdminPermission(state.url, navigation)) {
        return true;
      }

      return router.parseUrl(ADMIN_ERROR_404_PATH);
    })
  );
};
